import {useDefault} from '../../../common/common';
export class HotelAddress {
  street1: string;
  street2: string;
  city: string;
  zipCode: string;
  stateCode: string;
  stateName: string;
  countryCode: string;
  countryName: string;

  constructor (addressData: any) {
    this.street1 = useDefault(addressData.street1, '');
    this.street2 = useDefault(addressData.street2, '');
    this.city = useDefault(addressData.city, '');
    this.zipCode = useDefault(addressData.zip, '');
    if (addressData.state) {
      this.stateCode = useDefault(addressData.state.code, '');
      this.stateName = useDefault(addressData.state.name, '');
    }
    if (addressData.country) {
      this.countryCode = useDefault(addressData.country.code, '');
      this.countryName = useDefault(addressData.country.name, '');
    }
  }
}



// WEBPACK FOOTER //
// ./src/main/webapp/stay-mgmt/app/api/model/hotel/hotel-address.model.ts